import React from 'react';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import { BasePanelProps } from '../types';
import { SimplePanelContainer } from './styles';

export type SimplePanelProps = BasePanelProps & {
  forwardAs?: React.ElementType | keyof JSX.IntrinsicElements;
} & ComponentProps;

const SimplePanel: React.FC<SimplePanelProps> = ({
  colors,
  borderShadows,
  forwardAs,
  children,
  ...props
}) => (
  <SimplePanelContainer
    {...componentProps(props)}
    as={forwardAs}
    colors={colors}
    borderShadows={borderShadows}>
    {children}
  </SimplePanelContainer>
);

export default applyComponentTheme(SimplePanel, 'SimplePanel');
